<template>

  <!-- View task modal template -->
  <b-modal ref="view-task-modal" @hide="hideViewTaskModal" modal-class="task-modal">
    <template #modal-header="{ close }">
      <div class="" style="width: 100%;">
        <span @click="hideViewTaskModal" class="btn btn-secondary cursor-pointer float-right">
          <font-awesome-icon icon="times"/>
        </span>

        <div class="d-block text-center">
          <h5 qid="view-task-title">
            {{ selectedTaskObject.full_title }}
          </h5>
        </div>

        <div class="">
          <span class="small">{{ $t('table.last_updated') }}</span>
              <span class="ml-1 text-muted small" qid="view-task-modified-date">
            {{ selectedTaskObject.updated_at | formatDate }}
          </span>
          <Avatar v-if="selectedTaskObject.updated_by"
                  :object="selectedTaskObject.updated_by"
                  size="xs"
                  class="ml-2 mr-1"
          ></Avatar>
          <span v-if="selectedTaskObject.updated_by" class="ml-1 text-muted small" qid="view-task-modified-by">
            {{ selectedTaskObject.updated_by.name }}
          </span>
        </div>

        <div v-if="ownerTask && selectedTaskObject.description && selectedTaskObject.description.length">
          <p v-if="showFullDescription" class="text-formatted">
            {{ selectedTaskObject.description }}
          </p>
          <p v-if="!showFullDescription" class="text-formatted">
            {{ selectedTaskObject.description | truncate(300) }}
          </p>

          <div v-if="selectedTaskObject.description.length > 300" class="text-center mt-3" @click="showFullDescription=!showFullDescription">
            <span class="cursor-pointer" v-if="!showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_more') }}
              </span>
              <font-awesome-icon icon="chevron-down"/>
            </span>
            <span class="cursor-pointer" v-if="showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_less') }}
              </span>
              <font-awesome-icon icon="chevron-up"/>
            </span>
          </div>
        </div>

        <div v-if="!ownerTask && ownerDataCollection && selectedTaskObject.data_collection_description && selectedTaskObject.data_collection_description.length">
          <p v-if="showFullDescription" class="text-formatted">
            {{ selectedTaskObject.data_collection_description }}
          </p>
          <p v-if="!showFullDescription" class="text-formatted">
            {{ selectedTaskObject.data_collection_description | truncate(300) }}
          </p>

          <div v-if="selectedTaskObject.data_collection_description.length > 300" class="text-center mt-3" @click="showFullDescription=!showFullDescription">
            <span class="cursor-pointer" v-if="!showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_more') }}
              </span>
              <font-awesome-icon icon="chevron-down"/>
            </span>
            <span class="cursor-pointer" v-if="showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_less') }}
              </span>
              <font-awesome-icon icon="chevron-up"/>
            </span>
          </div>
        </div>
      </div>
    </template>

    <b-form qid="view-task-form" v-if="selectedTaskObject && selectedTaskObject.project">
      <div class="form-container" v-if="selectedTaskObject && selectedTaskObject.code != 'system_impact_assessment' && selectedTaskObject.code != 'risk_assessment' && selectedTaskObject.code != 'control_assessment'">
        <b-form-group class="mb-4">
          <div v-if="selectedTaskObject.scope">
            <font-awesome-icon icon="shield-alt" size="lg" class="mr-2"/>
            {{ selectedTaskObject.scope.name }}
          </div>
          <div v-if="selectedTaskObject.model && selectedTaskObject.project && selectedTaskObject.project.type != 'security_measure'" class="mt-3">
            <span v-if="selectedTaskObject.model">
              <font-awesome-icon
                icon="desktop"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\System\\Models\\System'"
              />
              <font-awesome-icon
                icon="cubes"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Activity\\Models\\Activity'"
              />
              <font-awesome-icon
                icon="cube"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Process\\Models\\Process'"
              />
              <font-awesome-icon
                icon="file-signature"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"
              />
            </span>
            {{ selectedTaskObject.model.name }}
          </div>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-project_message-label">
            {{ $t('tasks.modal.project_message_label') }}
          </label>
          <div v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length">
            <p v-if="showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message }}
            </p>
            <p v-if="!showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.project.schedule_message.length > 300" class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
              <span class="cursor-pointer" v-if="!showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length <= 300"
             class="text-formatted"
          >
            {{ selectedTaskObject.project.schedule_message }}
          </p>
        </b-form-group>

        <b-form-group v-if="selectedTaskObject && selectedTaskObject.scope">
          <label qid="view-task-generic_control_description-label">
            {{ $t('tasks.modal.generic_control_description_label') }}
          </label>
          <div v-if="selectedTaskObject.scope.description && selectedTaskObject.scope.description.length">
            <p v-if="showFullGenericControlDescription" class="text-formatted">
              {{ selectedTaskObject.scope.description }}
            </p>
            <p v-if="!showFullGenericControlDescription" class="text-formatted">
              {{ selectedTaskObject.scope.description | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.scope.description.length > 300" class="text-center mt-3" @click="showFullGenericControlDescription=!showFullGenericControlDescription">
              <span class="cursor-pointer" v-if="!showFullGenericControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullGenericControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="selectedTaskObject.scope.description && selectedTaskObject.scope.description.length <= 300"
             class="text-formatted"
          >
            {{ selectedTaskObject.scope.description }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-status-label">
            {{ $t('tasks.modal.status_label') }}
          </label>
          <p>
            <span v-if="selectedTaskObject.completion_status == 'pass'" class="badge badge-success pl-4 pr-4">
              {{ $t('system.passed') }}
            </span>
            <span v-if="selectedTaskObject.completion_status == 'fail'" class="badge badge-danger pl-4 pr-4">
              {{ $t('system.failed') }}
            </span>
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-remarks-label">
            {{ $t('tasks.modal.remarks_label') }}
          </label>
          <p class="text-formatted">{{ selectedTaskObject.remarks }}</p>
        </b-form-group>

        <div class="mt-2">
          <label>
            {{ $t('maintenance.policies.create.attachments') }}
          </label>
          <br>
          <p v-for="file in selectedTaskObject.media" :key="file.id">
            <span class="mr-3 float-right text-muted cursor-pointer"
                  @click="downloadMedia(file)"
                  qid="view-task-download-media"
            >
              <font-awesome-icon icon="cloud-download-alt" />
            </span>
            <a href="#" @click="downloadMedia(file)" qid="view-task-media-item">
              {{ file.file_name }}
            </a>
          </p>
        </div>

        <div class="mt-4">
          <label>
            {{ $t('maintenance.policies.create.links_label') }}
          </label>
          <div v-if="selectedTaskObject.links">
            <p v-for="link in selectedTaskObject.links" :key="link.id">
              <a :href="link.url" target="_blank" qid="view-task-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </p>
          </div>
          <br>
        </div>
      </div>

      <div class="form-container" v-if="selectedTaskObject && selectedTaskObject.code == 'risk_assessment'">
        <b-form-group class="mb-4">
          <div v-if="selectedTaskObject.scope">
            <font-awesome-icon icon="shield-alt" size="lg" class="mr-2"/>
            {{ selectedTaskObject.scope.name }}
          </div>
          <div v-if="selectedTaskObject.model && selectedTaskObject.project && selectedTaskObject.project.type != 'security_measure'" class="mt-3">
            <span v-if="selectedTaskObject.model">
              <font-awesome-icon
                icon="desktop"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\System\\Models\\System'"
              />
              <font-awesome-icon
                icon="cubes"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Activity\\Models\\Activity'"
              />
              <font-awesome-icon
                icon="cube"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Process\\Models\\Process'"
              />
              <font-awesome-icon
                icon="file-signature"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"
              />
            </span>
            {{ selectedTaskObject.model.name }}
          </div>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-project_message-label">
            {{ $t('tasks.modal.project_message_label') }}
          </label>
          <div v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length">
            <p v-if="showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message }}
            </p>
            <p v-if="!showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.project.schedule_message.length > 300" class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
              <span class="cursor-pointer" v-if="!showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length <= 300"
             class="text-formatted"
          >
            {{ selectedTaskObject.project.schedule_message }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-response-label">
            {{ $t('tasks.modal.response_label') }}
          </label>
          <p>
            {{ selectedTaskObject.response }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-remarks-label">
            {{ $t('tasks.modal.remarks_label') }}
          </label>
          <p class="text-formatted">{{ selectedTaskObject.remarks }}</p>
        </b-form-group>

        <div class="mt-2">
          <label>
            {{ $t('maintenance.policies.create.attachments') }}
          </label>
          <br>
          <p v-for="file in selectedTaskObject.media" :key="file.id">
            <span class="mr-3 float-right text-muted cursor-pointer"
                  @click="downloadMedia(file)"
                  qid="view-task-download-media"
            >
              <font-awesome-icon icon="cloud-download-alt" />
            </span>
            <a href="#" @click="downloadMedia(file)" qid="view-task-media-item">
              {{ file.file_name }}
            </a>
          </p>
        </div>

        <div class="mt-4">
          <label>
            {{ $t('maintenance.policies.create.links_label') }}
          </label>
          <div v-if="selectedTaskObject.links">
            <p v-for="link in selectedTaskObject.links" :key="link.id">
              <a :href="link.url" target="_blank" qid="view-task-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </p>
          </div>
          <br>
        </div>
      </div>

      <div class="form-container" v-if="selectedTaskObject && selectedTaskObject.code == 'system_impact_assessment'">
        <b-form-group class="mb-4">
          <div v-if="selectedTaskObject.scope">
            <font-awesome-icon icon="shield-alt" size="lg" class="mr-2"/>
            {{ selectedTaskObject.scope.name }}
          </div>
          <div v-if="selectedTaskObject.model && selectedTaskObject.project && selectedTaskObject.project.type != 'security_measure'" class="mt-3">
            <span v-if="selectedTaskObject.model">
              <font-awesome-icon
                icon="desktop"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\System\\Models\\System'"
              />
              <font-awesome-icon
                icon="cubes"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Activity\\Models\\Activity'"
              />
              <font-awesome-icon
                icon="cube"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Process\\Models\\Process'"
              />
              <font-awesome-icon
                icon="file-signature"
                size="lg"
                class="mr-2"
                v-if="selectedTaskObject.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"
              />
            </span>
            {{ selectedTaskObject.model.name }}
          </div>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-project_message-label">
            {{ $t('tasks.modal.project_message_label') }}
          </label>
          <div v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length">
            <p v-if="showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message }}
            </p>
            <p v-if="!showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.project.schedule_message.length > 300" class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
              <span class="cursor-pointer" v-if="!showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length <= 300"
             class="text-formatted"
          >
            {{ selectedTaskObject.project.schedule_message }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-confidentiality-label">
            {{ $t('processes.confidentiality.title') }}
          </label>
          <p>
            {{ selectedTaskObject.confidentiality }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-integrity-label">
            {{ $t('processes.integrity.title') }}
          </label>
          <p>
            {{ selectedTaskObject.integrity }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-availability-label">
            {{ $t('processes.availability.title') }}
          </label>
          <p>
            {{ selectedTaskObject.availability }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-rto_number-label">
            {{ $t('tasks.modal.rto_label') }}
          </label>
          <p>
            {{ selectedTaskObject.rto_number }} {{ selectedTaskObject.rto_type }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-rpo_type-label">
            {{ $t('tasks.modal.rpo_label') }}
          </label>
          <p>
            {{ selectedTaskObject.rpo_number }} {{ selectedTaskObject.rpo_type }}
          </p>
        </b-form-group>

        <b-form-group>
          <label qid="view-task-remarks-label">
            {{ $t('tasks.modal.remarks_label') }}
          </label>
          <p class="text-formatted">{{ selectedTaskObject.remarks }}</p>
        </b-form-group>
      </div>

      <div class="form-container" v-if="selectedTaskObject && selectedTaskObject.code == 'control_assessment'">
        <b-form-group v-if="selectedTaskObject.project.schedule_message">
          <label qid="view-task-project_message-label">
            {{ $t('tasks.modal.project_message_label') }}
          </label>
          <div v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length">
            <p v-if="showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message }}
            </p>
            <p v-if="!showFullProjectMessage" class="text-formatted">
              {{ selectedTaskObject.project.schedule_message | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.project.schedule_message.length > 300" class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
              <span class="cursor-pointer" v-if="!showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullProjectMessage">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="selectedTaskObject.project.schedule_message && selectedTaskObject.project.schedule_message.length <= 300"
             class="text-formatted"
          >
            {{ selectedTaskObject.project.schedule_message }}
          </p>
        </b-form-group>

        <b-form-group v-if="!ownerTask && ownerDataCollection && selectedTaskObject.data_remarks">
          <label qid="view-task-dc-control_description-label">
            {{ $t('tasks.modal.control_description_label') }}
          </label>

          <div v-if="selectedTaskObject.data_remarks && selectedTaskObject.data_remarks.length">
            <p v-if="showFullControlDescription" class="text-formatted">
              {{ selectedTaskObject.data_remarks }}
            </p>
            <p v-if="!showFullControlDescription" class="text-formatted">
              {{ selectedTaskObject.data_remarks | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.data_remarks.length > 300" class="text-center mt-3" @click="showFullControlDescription=!showFullControlDescription">
              <span class="cursor-pointer" v-if="!showFullControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
        </b-form-group>

        <b-form-group v-if="ownerTask && selectedTaskObject.control_description">
          <label qid="view-task-control_description-label">
            {{ $t('tasks.modal.control_description_label') }}
          </label>

          <div v-if="selectedTaskObject.control_description && selectedTaskObject.control_description.length">
            <p v-if="showFullControlDescription" class="text-formatted">
              {{ selectedTaskObject.control_description }}
            </p>
            <p v-if="!showFullControlDescription" class="text-formatted">
              {{ selectedTaskObject.control_description | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.control_description.length > 300" class="text-center mt-3" @click="showFullControlDescription=!showFullControlDescription">
              <span class="cursor-pointer" v-if="!showFullControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullControlDescription">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
        </b-form-group>

        <b-form-group v-if="ownerTask && selectedTaskObject.performed_text">
          <label qid="view-task-performed_test-label">
            {{ $t('tasks.modal.performed_test_label') }}
          </label>

          <div v-if="selectedTaskObject.performed_text && selectedTaskObject.performed_text.length">
            <p v-if="showFullPerformedTest" class="text-formatted">
              {{ selectedTaskObject.performed_text }}
            </p>
            <p v-if="!showFullPerformedTest" class="text-formatted">
              {{ selectedTaskObject.performed_text | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.performed_text.length > 300" class="text-center mt-3" @click="showFullPerformedTest=!showFullPerformedTest">
              <span class="cursor-pointer" v-if="!showFullPerformedTest">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPerformedTest">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
        </b-form-group>

        <b-form-group v-if="ownerTask && selectedTaskObject.response">
          <label qid="view-task-response-label">
            {{ $t('tasks.modal.response_label') }}
          </label>
          <p>
            {{ selectedTaskObject.response }}
          </p>
        </b-form-group>

        <b-form-group v-if="ownerTask && selectedTaskObject.remarks">
          <label qid="view-task-remarks-label">
            {{ $t('tasks.modal.remarks_label') }}
          </label>

          <div v-if="selectedTaskObject.remarks && selectedTaskObject.remarks.length">
            <p v-if="showFullConclusion" class="text-formatted">
              {{ selectedTaskObject.remarks }}
            </p>
            <p v-if="!showFullConclusion" class="text-formatted">
              {{ selectedTaskObject.remarks | truncate(300) }}
            </p>
            <div v-if="selectedTaskObject.remarks.length > 300" class="text-center mt-3" @click="showFullConclusion=!showFullConclusion">
              <span class="cursor-pointer" v-if="!showFullConclusion">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullConclusion">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
        </b-form-group>

        <div class="mt-2" v-if="selectedTaskObject.media && selectedTaskObject.media.length">
          <label>
            {{ $t('maintenance.policies.create.attachments') }}
          </label>
          <br>
          <p v-for="file in selectedTaskObject.media" :key="file.id">
            <span class="mr-3 float-right text-muted cursor-pointer"
                  @click="downloadMedia(file)"
                  qid="view-task-download-media"
            >
              <font-awesome-icon icon="cloud-download-alt" />
            </span>
            <a href="#" @click="downloadMedia(file)" qid="view-task-media-item">
              {{ file.file_name }}
            </a>
          </p>
        </div>

        <div class="mt-4" v-if="selectedTaskObject.links && selectedTaskObject.links.length">
          <label>
            {{ $t('maintenance.policies.create.links_label') }}
          </label>
          <div v-if="selectedTaskObject.links">
            <p v-for="link in selectedTaskObject.links" :key="link.id">
              <a :href="link.url" target="_blank" qid="view-task-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </p>
          </div>
          <br>
        </div>
      </div>
    </b-form>

    <template #modal-footer="{ close }">
      <div class="" style="width: 100%;">
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <b-button @click="hideViewTaskModal"
                        class="ml-3"
                        variant="secondary"
                        qid="view-task-close-button"
              >
                {{ $t('system.close') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'TaskViewModal',
    data: function() {
      return {
        error: '',
        project: {},
        selectedTaskObject: {},
        tasks: [],
        loading: true,

        ownerTask: false,
        ownerDataCollection: false,

        showFullDescription: false,
        showFullControlDescription: false,
        showFullPerformedTest: false,
        showFullConclusion: false,
        showFullProjectMessage: false,
        showFullGenericControlDescription: false,
      }
    },
    props: {
      selectedTask: {},
      showModal: {
        type: Boolean
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.loadTaskById(this.selectedTask.id)
          //this.showViewTaskModal()
        }
      }
    },
    methods: {
      showViewTaskModal(object) {
        let self = this;
        this.error = '';

        this.$refs['view-task-modal'].show();
      },
      hideViewTaskModal() {
        let self = this;
        this.error = '';

        this.$emit('closeViewModal');
        this.$refs['view-task-modal'].hide()
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      loadTaskById(id) {
        let self = this;

        piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTaskObject = response.data;

          if (self.selectedTaskObject.users && self.selectedTaskObject.users.length) {
            _.forEach(self.selectedTaskObject.users, function (user) {
              if (user.id == self.getUser.id) {
                self.ownerTask = true;
              }
            })
          }

          if (self.selectedTaskObject.data_users && self.selectedTaskObject.data_users.length) {
            _.forEach(self.selectedTaskObject.data_users, function (user) {
              if (user.id == self.getUser.id) {
                self.ownerDataCollection = true;
              }
            })
          }

          self.showViewTaskModal()
        }, function() {});
      },

    },
    created () {

    }
  }
</script>
